module.exports = "/_next/static/images/ece4ba5d0bc5522f64bb8820b7be8ea1-woman-holding-device-smiling@1x.jpg";